import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      minWidth: 'unset',
      color: COLORS.gray.gray30,
      height: '100%',
    },
    iconChevron: {
      '&&': {
        fontSize: theme.typography.pxToRem(12),
      },
    },
    menuRoot: {
      '& li i': {
        fontStyle: 'normal',
        color: COLORS.gray.gray50,
      },
    },
    iconCheck: {
      // styles are overridden by the default styles
      color: COLORS.primary.default + ' !important',
    },
    iconHidden: {
      visibility: 'hidden',
    },
  }),
  { name: 'EditorTypeDropdown' }
);
